export default {
  title:
    'How much pension will you get? Meet Your Future Self | Scottish Widows',
  description:
    'Meet Your Future Self lets you see what you could look like at retirement, how much pension you will get and how much you should be paying in each month.',
  endpoint: '/api/calculation',
  siteUrl: 'https://www.scottishwidowsyourfutureself.co.uk',
};
